import { FindingApi } from "@kdmanalytics/brm-system";
import BrmApiClient from "services/brm/BrmApiClient";

const findingApi = new FindingApi(BrmApiClient.instance);

export default findingApi;
